import { useEffect, useState, type ReactNode } from 'react';

/** Mount on first use, then retain the application's view and its native grid cache. */
export function RetainedView({ active, children }: { active: boolean; children: ReactNode }) {
  const [visited, setVisited] = useState(active);
  useEffect(() => {
    if (active) setVisited(true);
  }, [active]);
  return <div hidden={!active}>{active || visited ? children : null}</div>;
}
